/* tslint:disable */
/* eslint-disable */
/**
 * backend/api/v2beta1/recurring_run.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * PeriodicSchedule allow scheduling the recurring run periodically with certain interval.
 * @export
 * @interface V2beta1PeriodicSchedule
 */
export interface V2beta1PeriodicSchedule {
  /**
   * The start time of the periodic recurring run.
   * @type {Date}
   * @memberof V2beta1PeriodicSchedule
   */
  start_time?: Date;
  /**
   * The end time of the periodic recurring run.
   * @type {Date}
   * @memberof V2beta1PeriodicSchedule
   */
  end_time?: Date;
  /**
   * The time interval between the starting time of consecutive recurring runs.
   * @type {string}
   * @memberof V2beta1PeriodicSchedule
   */
  interval_second?: string;
}

/**
 * Check if a given object implements the V2beta1PeriodicSchedule interface.
 */
export function instanceOfV2beta1PeriodicSchedule(value: object): value is V2beta1PeriodicSchedule {
  return true;
}

export function V2beta1PeriodicScheduleFromJSON(json: any): V2beta1PeriodicSchedule {
  return V2beta1PeriodicScheduleFromJSONTyped(json, false);
}

export function V2beta1PeriodicScheduleFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): V2beta1PeriodicSchedule {
  if (json == null) {
    return json;
  }
  return {
    start_time: json['start_time'] == null ? undefined : new Date(json['start_time']),
    end_time: json['end_time'] == null ? undefined : new Date(json['end_time']),
    interval_second: json['interval_second'] == null ? undefined : json['interval_second'],
  };
}

export function V2beta1PeriodicScheduleToJSON(json: any): V2beta1PeriodicSchedule {
  return V2beta1PeriodicScheduleToJSONTyped(json, false);
}

export function V2beta1PeriodicScheduleToJSONTyped(
  value?: V2beta1PeriodicSchedule | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    start_time:
      value['start_time'] == null ? value['start_time'] : value['start_time'].toISOString(),
    end_time: value['end_time'] == null ? value['end_time'] : value['end_time'].toISOString(),
    interval_second: value['interval_second'],
  };
}
